import { Header } from 'semantic-ui-react';
import { PriorInvestor } from '~/types/company';
import { usePageType, useProjectContext, usePortfolioContext } from '~/hooks';
import './styles.scss';

interface PreferredInvestorsProps {
  type: 'CAPTION' | 'EXPANDED';
}

const PreferredInvestors = ({
  type,
}: PreferredInvestorsProps) => {
  const pageType = usePageType();
  const { project } = useProjectContext();
  const { portfolio } = usePortfolioContext();
  const preferredInvestors = pageType === 'project' ? project?.preferredInvestors : portfolio?.preferredInvestors;
  const preferredInvestorDetails = pageType === 'project' ? project?.preferredInvestorDetails : portfolio?.preferredInvestorDetails;
  const preferredInvestorNames = preferredInvestors?.map?.((preferredInvestor: PriorInvestor) => preferredInvestor.name).join('; ');

  const investorPreference = (
    <>
      <span style={{ fontWeight: 400 }}>
        {preferredInvestors.length > 0 ? preferredInvestorNames : 'N/A'}
      </span>
    </>
  );

  if (type === 'CAPTION') {
    return (
      <div>
        <p className='caption' style={{ textAlign: 'center' }}>
          {investorPreference}
        </p>
      </div>
    );
  } else if (type === 'EXPANDED') {
    return (
      <div style={{ marginLeft: '24px'}}>
        <Header style={{ fontSize: '0.875rem', marginBottom: '6px' }}>Investor preferences</Header>
        <div className="preferred-investors-container" >
          {investorPreference} { preferredInvestorDetails ? ' - ' + preferredInvestorDetails : ''}
        </div>
      </div>
    );
  }

  return null;
};

export default PreferredInvestors;